//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../no/TaggedObject.js";
import "../no/ScCollector.js";
import "../Routing/Routing.SelectPort.js";
import "../no/Die.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
let d=[[[1,"BackingFace",0,"ScCollector",0],[0,"Curve",0,"Curve",0],[0,"Limits",0,"Die.DieLimitsBuilder",0],[1,"MasterEdge",0,"ScCollector",0],[1,"PlacementFace",0,"ScCollector",0],[1,"PrimaryEdge",0,"ScCollector",0],[1,"PrimaryFace",0,"ScCollector",0],[1,"RoutingObject",0,"Routing.SelectPort",0],[1,"SecondaryEdge",0,"ScCollector",0],[1,"SecondaryFace",0,"ScCollector",0],[1,"TargetFace",0,"ScCollector",0],[0,"UseCallbackValues",1,0],[0,"WeldType",1,0],[0,"WeldingCharacteristics",0,"Weld.CharacteristicsBuilder",0]],[[[],"DeleteCurve",{},0,0],[[],"ReadEdgePrepValues",{R_:{valuesBuilder:"Weld.EdgePrepValuesBuilder"}},0,0],[["valuesBuilder"],"SaveEdgePrepValues",{},1,0],[[],"GetPortEngagement",{R_:{engagement:''}},0,0],[["message"],"SetCallbackMessage",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Weld.JointItemBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.JointItemBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;